export enum ProjectViewMode {
    List,
    Create
}